import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

// import { LinkContainer } from "react-router-bootstrap"
import { 
  Grid, Col, PageHeader, Well, Glyphicon,
  Form, FormGroup, ControlLabel, FormControl, Button
} from "react-bootstrap"
import DatePicker from "react-bootstrap-date-picker"

import { Map, fromJS } from "immutable"
// import uuidv4 from "uuid"
// import numeral from "numeral"
import moment from "moment-timezone"
import "moment/locale/id"

import * as actionCreators from "../actions"

const listAddress = "/expenses"
const recordType = "expenses"

const newExpense = fromJS({
  uuid: "",
  expenseDate: moment(),
  description: "",
  amount: 0
})

class Expense extends Component {
  static propTypes = {
    expense: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  }

  state = {
    edited: Map()
  }

  getValue = (name, isDate = false) => {
    let value = (this.state.edited && this.state.edited.get(name)) || (this.props.record && this.props.record.get(name)) || ""
    return (isDate ? (value ? moment(value).format() : moment().format()) : value)
  }

  handleChange = e => {
    const { name } = e.target
    let { value } = e.target

    if (name === "amount") {
      value = Number(value)
    }
    
    this.setState((prev, props) => ({ edited: prev.edited.set(name, value) }))
  }

  handleCancel = e => {
    if (this.state.edited.size === 0 || window.confirm("Are you sure you want to cancel?")) {
      this.props.history.push(listAddress)
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    let record = this.state.edited
    let errors = ""
    
    // Check mandatory fields
    if (!this.getValue("expenseDate")) {
      errors += (errors.length > 0 ? "\n" : "") + "Tanggal is required!"
    }
    if (!this.getValue("description")) {
      errors += (errors.length > 0 ? "\n" : "") + "Keterangan is required!"
    }
    if (!this.getValue("amount")) {
      errors += (errors.length > 0 ? "\n" : "") + "Biaya is required!"
    }

    if (this.props.uuid === "new") { // new record      
      if (errors) {
        alert(errors)
        return
      } else {
        this.props.actions.createExpense(record)
      }
    } else { // existing record
      if (errors) {
        alert(errors)
        return
      } else {
        this.props.actions.updateExpense(this.props.uuid, record)
      }
    }

    // Reset edited state
    this.setState({ edited: Map() })
    this.props.history.push(listAddress)
  }

  handleExpenseDateChange = (value, formattedValue) => {
    this.setState((prev, props) => ({ edited: prev.edited.set("expenseDate", moment(value).format()) }))
  }

  render() {
    return (
      <Grid>
        <PageHeader>Expense</PageHeader>

        <Form horizontal onSubmit={this.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Tanggal</Col>
            <Col sm={10}>
            <DatePicker name="expenseDate" placeholder="Tanggal" showClearButton={false}
              value={this.getValue("expenseDate", true)}
              onChange={this.handleExpenseDateChange} />
          </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Keterangan</Col>
            <Col sm={10}>
              <FormControl
                name="description"
                placeholder="Keterangan"
                value={this.getValue("description")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Biaya</Col>
            <Col sm={10}>
              <FormControl className="text-right" type="number"
                name="amount"
                placeholder="Biaya"
                value={this.getValue("amount")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
        </Form>
          
        <Well bsSize="small">
          <Button className="pull-right" bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
            <Glyphicon glyph="save" /> Save
          </Button>
          <Button bsSize="small" bsStyle="danger" onClick={this.handleCancel}>
            <Glyphicon glyph="remove" /> Cancel
          </Button>
        </Well>
      </Grid>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  uuid: ownProps.match.params.id,
  record: ownProps.match.params.id === "new" ? newExpense : state.getIn([recordType, ownProps.match.params.id])
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Expense))



// WEBPACK FOOTER //
// ./src/components/Expense.js